import {hashHistory} from 'react-router'
import {take, call, put, race} from 'redux-saga/effects'
import auth from '../api/auth'

import {
  SENDING_AUTH_REQUEST,
  LOGIN_REQUEST,
  REGISTER_REQUEST,
  SET_AUTH,
  LOGOUT,
  CHANGE_AUTH_FORM,
  REQUEST_AUTH_ERROR,
  CLEAR_AUTH_ERROR,
  SET_USER,
  SET_SYSTEM,
  SENDING_ACCOUNT_REGISTER,
  REGISTER_ACCOUNT_REQUEST,
  REGISTER_ACCOUNT_SUCCESS,
  REGISTER_ACCOUNT_FAILURE,
  SENDING_FORGOT_PASSWORD_REQUEST,
  FORGOT_PASSWORD_REQUEST,
  FORGOT_PASSWORD_SUCCESS,
  FORGOT_PASSWORD_FAILURE,
  SENDING_VERIFY_CODE_RESET_PASSWORD_REQUEST,
  VERIFY_CODE_RESET_PASSWORD_REQUEST,
  VERIFY_CODE_RESET_PASSWORD_FAILURE,
  SENDING_RESET_PASSWORD_REQUEST,
  RESET_PASSWORD_REQUEST,
  RESET_PASSWORD_SUCCESS,
  RESET_PASSWORD_FAILURE
} from '../actions/constants'
import {putNotify} from './utils'

function* authorize({username, password, remember}) {
  yield put({type: SENDING_AUTH_REQUEST, sending: true})
  try {
    return yield call(auth.postLogin, username, password, remember)
  } catch (error) {
    yield put({type: REQUEST_AUTH_ERROR, error: error.message})
    return false
  } finally {
    yield put({type: SENDING_AUTH_REQUEST, sending: false})
  }
}

export function* logout() {
  yield put({type: SENDING_AUTH_REQUEST, sending: true})

  try {
    const response = yield call(auth.logout)
    yield put({type: SENDING_AUTH_REQUEST, sending: false})

    return response
  } catch (error) {
    yield put({type: REQUEST_AUTH_ERROR, error: error.message})
  }
}

export function* loginFlow() {
  while (true) {
    const request = yield take(LOGIN_REQUEST)
    const {username, password, remember, nextUrl} = request.data;
    const winner = yield race({
      auth: call(authorize, {username, password, remember, isRegistering: false}),
      logout: take(LOGOUT)
    })
    if (winner.auth) {
      const {
        user_id,
        user_name,
        full_name,
        role,
        notification_mode,
        //require_change_password,
        //require_otp,
        system_id,
        system_name,
        token
      } = winner.auth

      yield put({type: SET_AUTH, newAuthState: true})
      yield put({
        type: SET_USER,
        newUserState: {
          user_id: user_id,
          user_name: user_name,
          full_name: full_name,
          role: role,
          notification_mode: notification_mode,
          token: token
        }
      })
      yield put({
        type: SET_SYSTEM,
        newSystemState: {
          ID: system_id,
          Name: system_name
        }
      })
      yield put({
        type: CHANGE_AUTH_FORM,
        newFormState: {
          username: '',
          password: ''
        }
      }) // Clear form
      yield put({type: CLEAR_AUTH_ERROR})
      forwardTo(nextUrl)
    }
  }
}

export function* logoutFlow() {
  while (true) {
    const request = yield take(LOGOUT)
    const {nextUrl} = request.data;
    yield put({type: SET_AUTH, newAuthState: false})
    yield put({
      type: SET_USER,
      newUserState: {
        user_id: '',
        user_name: '',
        full_name: '',
        role: 0,
        notification_mode: 0,
        token: ''
      },
      loggedIn: false
    })
    yield call(logout)
    forwardTo(nextUrl)
  }
}

function* registerRequest({newRegisterState}) {
  yield put({type: SENDING_ACCOUNT_REGISTER, sending: true})
  try {
    return yield call(auth.postRegister, newRegisterState)
  } catch (error) {
    yield put({type: REGISTER_ACCOUNT_FAILURE, error: error.message})
  } finally {
    yield put({type: SENDING_ACCOUNT_REGISTER, sending: false})
  }
}

export function* watchRegister() {
  while (true) {
    const {newRegisterState} = yield take(REGISTER_ACCOUNT_REQUEST)
    const res = yield call(registerRequest, {newRegisterState})
    if (res) {
      if (res.error !== "") {
        yield put({type: REGISTER_ACCOUNT_FAILURE, error: res.error})
      } else {
        const urlSuccess = `/register-success/${newRegisterState.email}`
        forwardTo(urlSuccess)
      }
    }
  }
}

function* forgotPassworddRequest({emailState}) {
  yield put({type: SENDING_FORGOT_PASSWORD_REQUEST, sending: true})
  try {
    return yield call(auth.fetchForgotPassword, emailState)
  } catch (error) {
    yield put({type: FORGOT_PASSWORD_FAILURE, error: error.message})
  } finally {
    yield put({type: SENDING_FORGOT_PASSWORD_REQUEST, sending: false})
  }
}

export function* watchForgotPasswordRequest() {
  while (true) {
    const {emailState} = yield take(FORGOT_PASSWORD_REQUEST)
    const response = yield call(forgotPassworddRequest, {emailState})
    if (response) {
      const notify = 'Hệ thống đã gửi email thay đổi mật khẩu.'
      yield call(putNotify, {response, notify})
    }
  }
}

function* verifyCodeChangePassworddRequest({verifyCodeState}) {
  yield put({type: SENDING_VERIFY_CODE_RESET_PASSWORD_REQUEST, sending: true})
  try {
    return yield call(auth.verifyCodeChangePassword, verifyCodeState)
  } catch (error) {
    const urlFailure = `/forgot-password`
    forwardTo(urlFailure)
    yield put({type: VERIFY_CODE_RESET_PASSWORD_FAILURE, error: "Yêu cầu thay đổi mật khẩu không hợp lệ, vui lòng thử lại!"})
  } finally {
    yield put({type: SENDING_VERIFY_CODE_RESET_PASSWORD_REQUEST, sending: false})
  }
}

export function* watchVerifyCodeChangePasswordRequest() {
  while (true) {
    const {verifyCodeState} = yield take(VERIFY_CODE_RESET_PASSWORD_REQUEST)
    yield call(verifyCodeChangePassworddRequest, {verifyCodeState})
  }
}

function* resetPasswodRequest({passwordState}) {
  yield put({type: SENDING_RESET_PASSWORD_REQUEST, sending: true})
  try {
    return yield call(auth.postResetPassword, passwordState)
  } catch (error) {
    yield put({type: RESET_PASSWORD_FAILURE, error: error.message})
  } finally {
    yield put({type: SENDING_RESET_PASSWORD_REQUEST, sending: false})
  }
}

export function* watchResetPasswodRequest() {
  while (true) {
    const {passwordState} = yield take(RESET_PASSWORD_REQUEST)
    const response = yield call(resetPasswodRequest, {passwordState})
    if (response) {
      const {
        user_id,
        user_name,
        full_name,
        role,
        notification_mode,
        //require_change_password,
        //require_otp,
        system_id,
        system_name,
        token
      } = response

      yield put({type: SET_AUTH, newAuthState: true})
      yield put({
        type: SET_USER,
        newUserState: {
          user_id: user_id,
          user_name: user_name,
          full_name: full_name,
          role: role,
          notification_mode: notification_mode,
          token: token
        }
      })
      yield put({
        type: SET_SYSTEM,
        newSystemState: {
          ID: system_id,
          Name: system_name
        }
      })
      yield put({
        type: CHANGE_AUTH_FORM,
        newFormState: {
          username: '',
          password: ''
        }
      }) // Clear form
      yield put({type: CLEAR_AUTH_ERROR})
      forwardTo("/")
    }
  }
}

function forwardTo(location) {
  hashHistory.push(location)
}



// WEBPACK FOOTER //
// ./src/sagas/auth.js